import { ErrorComp } from "components/error"
import Head from "components/head";

const Error = () => {
  return (
    <>
      <Head />
      <ErrorComp />
    </>
  )
}

export default Error;